<script setup>
import { computed } from 'vue';
import { useRoute, RouterLink } from 'vue-router';

const propsSubmenuItem = defineProps({
  routerLink: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
});

const route = useRoute();

const isActive = computed(() => {
  return route.name === propsSubmenuItem.routerLink;
});

defineExpose({
  propsSubmenuItem,
});
</script>
<template>
  <ul class="navigation m-0 p-0 submenu-item-navigation">
    <li class="nav-item m-0 submenu-item" :class="{ active: isActive }">
      <router-link :to="{ name: routerLink }" class="d-flex align-items-center px-0 m-0">
        <i class="fa-regular fa-circle mx-1 submenu-item-icon"></i>
        <span class="menu-title text-truncate">{{ propsSubmenuItem.title }}</span>
      </router-link>
    </li>
  </ul>
</template>
<style scoped>
.submenu-item.active {
  background: none;
  box-shadow: none;
}

.submenu-item.active > a {
  background-color: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  border-radius: 4px;
}

.submenu-item.active > a > i {
  color: #7367f0;
}

.submenu-item-icon {
  visibility: hidden;
  margin-left: 6px;
}

.submenu-item {
  width: 230px;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .submenu-item .menu-title {
  height: 0px;
  visibility: hidden;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu.expanded .submenu-item .menu-title {
  height: auto;
  visibility: visible;
}
</style>
